import React from "react";


export default function LinkedInComplianceModal({ visible, onAccept, onCancel }) {
  if (!visible) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h2 style={styles.title}>LinkedIn Content Use Notice</h2>

        <p style={styles.text}>
          <strong>EmployPilot does not import, modify, or access your LinkedIn account in any way.</strong>
          <br /><br />
          This feature only analyzes the information <em>you choose to provide</em> and generates helpful
          recommendations or formatted content.
          <br /><br />
          You are responsible for manually copying any generated content into your LinkedIn profile.
          <br /><br />
          By proceeding, you confirm that you understand this tool is for guidance only and not an automated
          LinkedIn editing service.
        </p>

        <div style={styles.buttons}>
          <button style={styles.accept} onClick={onAccept}>I Understand</button>
          <button style={styles.cancel} onClick={onCancel}>Cancel</button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    top: 0, left: 0,
    width: "100vw",
    height: "100vh",
    background: "rgba(0,0,0,0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999
  },
  modal: {
    background: "#fff",
    width: "460px",
    padding: "25px",
    borderRadius: "12px",
    boxShadow: "0px 0px 20px rgba(0,0,0,0.2)",
    fontFamily: "Inter, sans-serif"
  },
  title: {
    marginBottom: "15px",
    fontSize: "20px",
    fontWeight: "bold"
  },
  text: {
    fontSize: "15px",
    lineHeight: "1.5",
    color: "#444",
    marginBottom: "20px"
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px"
  },
  accept: {
    background: "#007bff",
    color: "#fff",
    border: "none",
    padding: "8px 16px",
    borderRadius: "6px",
    cursor: "pointer"
  },
  cancel: {
    background: "#ccc",
    color: "#000",
    border: "none",
    padding: "8px 16px",
    borderRadius: "6px",
    cursor: "pointer"
  }
};
